<template>
  <svg width="17" height="20" viewBox="0 0 17 20"  xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_5499_405" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="20">
      <rect y="0.5" width="17" height="19" :fill="fill"/>
    </mask>
    <g mask="url(#mask0_5499_405)">
      <path d="M13.5121 16.6303C12.0837 16.5115 10.729 16.119 9.44808 15.4527C8.16717 14.7863 7.01908 13.8858 6.0038 12.7511C4.98853 11.6164 4.18575 10.3332 3.59547 8.90162C3.00519 7.47002 2.65693 5.95596 2.55068 4.35943C2.52707 4.08234 2.60085 3.84155 2.77203 3.63703C2.94321 3.43252 3.15276 3.33026 3.40068 3.33026H5.80901C6.00971 3.33026 6.18384 3.39953 6.33141 3.53807C6.47898 3.67662 6.57637 3.85144 6.6236 4.06255L7.0486 6.18026C7.07221 6.35179 7.06335 6.51672 7.02203 6.67505C6.98071 6.83339 6.91283 6.96533 6.81839 7.07089L5.10068 9.01047C5.33679 9.51186 5.60832 9.99346 5.91526 10.4553C6.22221 10.9171 6.56457 11.3525 6.94235 11.7615C7.29651 12.1573 7.67429 12.5235 8.07568 12.8599C8.47707 13.1964 8.90207 13.4966 9.35068 13.7605L11.1038 11.8605C11.1982 11.7549 11.3163 11.679 11.458 11.6329C11.5996 11.5867 11.7472 11.5768 11.9007 11.6032L13.7955 12.0584C13.9962 12.1244 14.1555 12.2398 14.2736 12.4047C14.3917 12.5697 14.4507 12.7643 14.4507 12.9886V15.6803C14.4507 15.9573 14.3562 16.1915 14.1673 16.3829C13.9785 16.5742 13.7601 16.6566 13.5121 16.6303Z" fill="#62A3FF"/>
    </g>
  </svg>

</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    fill?: string
  }>(),
  {
    fill: '#D9D9D9',
  },
)
</script>
